import { render, staticRenderFns } from "./SingleCheckboxInput.vue?vue&type=template&id=2315578d&"
import script from "./SingleCheckboxInput.vue?vue&type=script&lang=js&"
export * from "./SingleCheckboxInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports